import {
  Form,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LegalCustomerForm from '../../../forms/LegalCustomerForm';
import { getLoginFormOptions } from '../../../../../services/login/Login.api';
import { registerLegalCustomer } from '../../../../../services/customer/authServices';
import formSetDynamicErrors from '../../../../../utils/functions/formSetDynamicErrors';

function AddPhysicalCustomer() {
  const [form] = Form.useForm();
  const [options, setOptions] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getFormOptions = async () => {
    setLoading(true);
    const res = await getLoginFormOptions();
    setOptions(res.data);
    setLoading(false);
  };

  useEffect(() => {
    getFormOptions();
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await registerLegalCustomer({
        ...values,
        repeat_password: values?.password,
        agree_to_service_conditions: true,
        verified_email: true,
        verified_phone: true,
      });
      if (res.status === 'success') {
        navigate('/admin/customers');
      }
    } catch (e) {
      formSetDynamicErrors({ e, form });
    }
    setLoading(false);
  };

  return (
    <LegalCustomerForm options={options} form={form} onFinish={onFinish} loading={loading} />
  );
}

export default AddPhysicalCustomer;
